exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-pdless[data-v-5fffdcd1] {\n  padding: 0.3rem 0.8rem !important;\n}\n", ""]);

// exports
